<div #calendarWrapper>
    <full-calendar #calendar
     [options]="calendarOptions" 
     class="horizontal-calendar"
     [events]="events">
    </full-calendar>
</div>